export const loginUrl = "/auth/login";
export const logoutPath = "/auth/logout";
export const changePasswordPath = "/auth/change_password";
export const changeEmailPath = "/auth/change_email";
export const enableTwoFaPath = "/auth/enable_twofa";
export const disableTwoFaPath = "/auth/disable_twofa";
export const resendEmailPath = "/auth/resend";
export const deleteUserPath = "/auth/delete_user";
export const inviteUserPath = "/auth/invite";
export const loginCheckUrl = "/auth/check";
export const webhookSecurityPath = "/auth/webhook_security";
export const loginCheckEventKey = "auth-check-completed";
